<template>
    <div class="main">
        <div class="top">
            <div class="title-img">
                <img src="https://i.tmuyun.com/webpic/W0202407/W020240719/W020240719497281075327.png" />
            </div>
            <div class="video-list">
                <div class="video">
                    <div class="screen">
                        <video
                            ref="videoPlayer"
                            class="video-js vjs-default-skin vjs-big-play-centered video-one"
                            x-webkit-airplay="true"
                            webkit-playsinline=""
                            playsinline="true"
                        ></video>
                        <div class="info">
                            <div class="title">{{ video.title }}</div>
                            <van-tag color="#bbbbbb" plain v-if="video.hasWatched == 0"
                            >未完成</van-tag
                            >
                            <van-tag color="#ffea00" plain v-else>已完成</van-tag>
                        </div>

                        <div class="van-hairline--top notice">
                            <van-notice-bar
                            wrapable
                            :scrollable="false"
                            left-icon="volume-o"
                            text="温馨提示：第一次观看视频满30秒后+10分！"
                            ></van-notice-bar>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script scoped>
import 'video.js/dist/video-js.css'
import {
getVideoDetail,
  getUserInfo,
  saveVideoHistoryWithIntegral,
} from '@/api/snjx'

import videojs from 'video.js'
import { Toast } from 'vant'

export default {
  name: 'Video',
  data() {
    return {
      video: {},
      options: {
        height: 230,
        autoplay: false,
        controls: true,
        controlBar: {
          playToggle: true,
          captionsButton: false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: true,
          progressControl: {
            seekBar: false
          },
        //   fullscreenToggle: false,
          playbackRateMenuButton: false
        },
        poster: '',
        sources: [
          {
            src: '',
            type: 'video/mp4'
          }
        ]
      },
      themeId: 1,
      deviceNo: '', //设备号
      isLoading: false
    }
  },
  created() {
    getVideoDetail({ id: this.$route.params.id }).then((res) => {
      if (res.code == 1) {
        this.video = {
          id: this.$route.params.id,
          status: 0,
          title: res.data.title,
          poster: res.data.cover,
          src: res.data.url,
          from: res.data.from,
          hasWatched:res.data.hasWatched,
        }
        this.options.poster = this.video.poster
        this.options.sources[0].src = this.video.src
        let self = this
        this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {
            // console.log('onPlayerReady', this)
            // this.controlBar.progressControl.disable();

            this.on('timeupdate', function() {
                // 获取当前播放时间，单位是秒
                var currentTime = this.currentTime();
                // console.log('当前播放时间：', currentTime);
                if(currentTime >= 30 && self.isLoading === false && !self.video.hasWatched){
                    // console.log(2);
                    self.onPlayEnded()
                }
                
                // 可以在这里添加更多的逻辑，比如更新播放进度条等
            });

            this.on('ended', () => {
              self.onPlayEnded()
            })
          }
        )
      }
    })
  },
  mounted() {
    getUserInfo({theme_id: this.themeId}).then((res) => {
      if (res.code == 1 && res.data == null) {
        Toast({
            type: 'fail',
            message: '请先注册',
            onClose: () => {
                this.$router.push({ name: 'snjx_register' })
            }
        })
      }
    })
  
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    onPlayEnded() {
        if(!this.video.hasWatched){
            if (this.isLoading) return;
            this.isLoading = true;

            let postData = { video_id: this.$route.params.id, theme_id: this.themeId};

            //上报视频播放记录
            saveVideoHistoryWithIntegral(postData).then((res) => {
                if(res.code == 1){
                    this.video.hasWatched = 1;
                    if (res.msg) {
                        Toast.success(res.msg)
                    }
                    this.isLoading = false;
                }else{
                    Toast.fail(res.msg)
                }
                // console.log('上报视屏播放记录')
            })
            
            // console.log('ended')
            
        }
    },
    
    
  }
}
</script>
<style lang="less" scoped>

.video-js {
  width: 100%;
}

.main {
    height: 100vh;
    background-color: #F5F5F5;
}

.top {
    background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718694322070720.png') no-repeat;
    background-size: 100%;
}

.title-img{
    margin: 0 auto;
    width: 375px;
    img{ width: 100%;}
}

.video-list{
    position: absolute;
    top: 250px;
    width: 100%;
    .video {
        width: 300px;
        margin: 0 auto 10px auto;
        padding: 10px;
        background: #fff;
        border-radius: 10px;

        .info {
            padding: 5px;
            margin-bottom: 10px;
        }
        .notice {
            padding-top: 10px;
        }
        
        .screen{
            width: 300px;
            height: 170px;
        }
    }
}
</style>